module.exports = __webpack_public_path__ + "media/images/pic/meat-transport-651e70ce30e0e045f24228f4087eba4a.webp";